module.exports = {
  title: 'Atlas Sphere with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2024-06-25',
  slug: 'atlas-sphere',
  tags: ['skia', 'gesture-handler'],
};
